import { getBranches } from '../../services/api/branch.api';
import { GET_BRANCHES_LIST_REQUEST, GET_BRANCHES_LIST_SUCCESS, GET_BRANCHES_LIST_FAILURE } from '../types';
import { transformBranches } from '../../transforms/branch';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformBranches([]),
		pagination: transformPagination({}),
	},

	getters: {
		branchOptions: (state) => {
			const branch = {
				name: 'All branches',
				value: null,
			};

			const branches = state.data.map((item) => {
				return {
					name: item.nameTH,
					value: item.itecBranchId,
				};
			});

			return [branch, ...branches];
		},
	},

	mutations: {
		[GET_BRANCHES_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_BRANCHES_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformBranches(data);
			state.pagination = transformPagination(meta);
		},
		[GET_BRANCHES_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getBranches({ commit }) {
			try {
				const params = {
					per_page: 'all',
				};
				commit(GET_BRANCHES_LIST_REQUEST);
				const { data } = await getBranches(params);
				commit(GET_BRANCHES_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_BRANCHES_LIST_FAILURE, error);
			}
		},
	},
};